export * from './plugin';
export * from './decorators';
export * from './util';
export * from './ionic-native-plugin';



// WEBPACK FOOTER //
// ../../../src/@ionic-native/core/index.ts